/* eslint-disable import/no-default-export */
import API from 'app/gamma/src/api';
import { getMe } from 'app/gamma/src/selectors/members';
import { MemberResponse } from 'app/gamma/src/types/responses';
import { StandardThunkAction, Dispatch } from 'app/gamma/src/types';
import { Action, actionCreator, createReducer } from '@trello/redux';

import { setLocalStorageUser } from 'app/gamma/src/util/application-storage';
import { State } from 'app/gamma/src/modules/types';

const LOGIN_GOOGLE = Symbol('models/LOGIN_GOOGLE');
const SET_MEMBER = Symbol('models/SET_MEMBER');

export const UPDATE_PASSWORD_REQUEST = Symbol('models/UPDATE_PASSWORD_REQUEST');
export const UPDATE_PASSWORD_SUCCESS = Symbol('models/UPDATE_PASSWORD_SUCCESS');
export const UPDATE_PASSWORD_ERROR = Symbol('models/UPDATE_PASSWORD_ERROR');

type LoginAction = Action<typeof LOGIN_GOOGLE, TokenPayload>;
type SetMemberAction = Action<typeof SET_MEMBER, UserIdPayload>;

export type UpdatePasswordRequestAction = Action<
  typeof UPDATE_PASSWORD_REQUEST,
  null
>;
export type UpdatePasswordSuccessAction = Action<
  typeof UPDATE_PASSWORD_SUCCESS,
  MemberResponse
>;
export type UpdatePasswordErrorAction = Action<
  typeof UPDATE_PASSWORD_ERROR,
  string
>;

interface UserIdPayload {
  idMe: string | null;
}

interface TokenPayload {
  id: string;
  token: string;
}

export interface SessionState {
  idMe: string;
  token?: string;
}
// Reducer
const initialState: SessionState = {
  idMe: '',
};

export default createReducer(initialState, {
  [LOGIN_GOOGLE](state, { payload }: LoginAction) {
    const { id } = payload;

    return { ...state, idMe: id };
  },

  [SET_MEMBER](state, { payload }: SetMemberAction) {
    const { idMe } = payload;
    if (!idMe) {
      return state;
    }

    setLocalStorageUser(idMe);

    return { ...state, idMe };
  },
});

// Action creators
const updatePasswordRequest = actionCreator<UpdatePasswordRequestAction>(
  UPDATE_PASSWORD_REQUEST,
);
const updatePasswordSuccess = actionCreator<UpdatePasswordSuccessAction>(
  UPDATE_PASSWORD_SUCCESS,
);
export const updatePasswordError = actionCreator<UpdatePasswordErrorAction>(
  UPDATE_PASSWORD_ERROR,
);
export const loginGoogle = actionCreator<LoginAction>(LOGIN_GOOGLE);
export const setMember = actionCreator<SetMemberAction>(SET_MEMBER);

const serverToi18n: { [key: string]: string } = {
  'invalid value for newPassword': 'not long enough',
  'The old password was incorrect': 'old password',
};

export const updatePassword = (data: {
  oldPassword?: string;
  password1: string;
  password2: string;
}): StandardThunkAction => {
  return async (dispatch: Dispatch, getState: () => State) => {
    dispatch(updatePasswordRequest());

    const id = getMe(getState())!.id;
    try {
      const member = await API.client.rest.post<MemberResponse>(
        `members/${id}/updatePassword`,
        {
          query: {
            oldPassword: data.oldPassword,
            newPassword: data.password1,
          },
        },
      );

      dispatch(updatePasswordSuccess(member));
    } catch (err) {
      if (err instanceof Error) {
        const message = serverToi18n[err.message.split(':')[1].trim()];

        dispatch(updatePasswordError(message || 'unknown'));
      } else {
        dispatch(updatePasswordError(err));
      }
    }
  };
};
